/**
 * An object containing properties for notification messages
 */
var Notification = /** @class */ (function () {
    function Notification() {
    }
    return Notification;
}());
export { Notification };
//# sourceMappingURL=notification.js.map